var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.244,
    height: 25.244,
    viewBox: "0 0 25.244 25.244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "announcement_1_",
    "data-name": "announcement (1)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16164",
    "data-name": "Path 16164",
    d: "M.421,186.517H1.683v5.049a.421.421,0,0,0,.421.421H6.311a.421.421,0,0,0,.421-.421v-8.415h3.787a.421.421,0,0,0,.421-.421v-1.052l4.466,1.861a.416.416,0,0,0,.162.032.42.42,0,0,0,.421-.421V176.42a.42.42,0,0,0-.582-.388L10.434,178.1h-1.6a.421.421,0,0,0-.421.421v2.1H6.084a2.524,2.524,0,1,0-3.753,0H2.1a2.106,2.106,0,0,0-2.1,2.1V186.1a.421.421,0,0,0,.421.421Zm14.725-4-4.207-1.753V178.8l4.207-1.753Zm-5.89-3.576H10.1v1.683H9.256Zm-6.732,0a1.683,1.683,0,1,1,1.683,1.683A1.685,1.685,0,0,1,2.524,178.944ZM.841,182.73A1.264,1.264,0,0,1,2.1,181.468H10.1v.841H6.311a.421.421,0,0,0-.421.421v8.415H4.628V186.1H3.787v5.049H2.524V182.73H1.683v2.945H.841Zm0,0",
    transform: "translate(0 -166.743)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16165",
    "data-name": "Path 16165",
    d: "M343.573,6.312a2.1,2.1,0,0,0-1.927-2.087,2.524,2.524,0,1,0-3.72,0A2.1,2.1,0,0,0,336,6.312v.84a.421.421,0,0,0,.421.421h6.732a.421.421,0,0,0,.421-.421ZM339.787.841A1.683,1.683,0,1,1,338.1,2.524,1.685,1.685,0,0,1,339.787.841Zm2.945,5.89h-5.89V6.312a1.266,1.266,0,0,1,1.264-1.264h3.363a1.266,1.266,0,0,1,1.264,1.264Zm0,0",
    transform: "translate(-318.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16166",
    "data-name": "Path 16166",
    d: "M343.573,174.312a2.1,2.1,0,0,0-1.927-2.087,2.524,2.524,0,1,0-3.72,0A2.1,2.1,0,0,0,336,174.312v.84a.421.421,0,0,0,.421.421h6.732a.421.421,0,0,0,.421-.421Zm-3.787-5.471a1.683,1.683,0,1,1-1.683,1.683A1.685,1.685,0,0,1,339.787,168.841Zm2.945,5.89h-5.89v-.419a1.266,1.266,0,0,1,1.264-1.264h3.363a1.266,1.266,0,0,1,1.264,1.264Zm0,0",
    transform: "translate(-318.33 -159.165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16167",
    "data-name": "Path 16167",
    d: "M343.573,342.312a2.1,2.1,0,0,0-1.927-2.087,2.524,2.524,0,1,0-3.72,0A2.1,2.1,0,0,0,336,342.312v.84a.421.421,0,0,0,.421.421h6.732a.421.421,0,0,0,.421-.421Zm-3.787-5.471a1.683,1.683,0,1,1-1.683,1.683A1.685,1.685,0,0,1,339.787,336.841Zm2.945,5.89h-5.89v-.419a1.266,1.266,0,0,1,1.264-1.264h3.363a1.266,1.266,0,0,1,1.264,1.264Zm0,0",
    transform: "translate(-318.33 -318.329)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16168",
    "data-name": "Path 16168",
    d: "M73.943,8.8a.421.421,0,0,0,.459-.091L77.223,5.89h4.454a1.264,1.264,0,0,0,1.262-1.262V1.263A1.264,1.264,0,0,0,81.677,0H73.263A1.264,1.264,0,0,0,72,1.263V4.628A1.264,1.264,0,0,0,73.263,5.89h.421V8.415a.421.421,0,0,0,.26.389Zm-.68-3.754a.421.421,0,0,1-.421-.421V1.263a.421.421,0,0,1,.421-.421h8.415a.421.421,0,0,1,.421.421V4.628a.421.421,0,0,1-.421.421H77.049a.419.419,0,0,0-.3.123L74.525,7.4V5.47a.421.421,0,0,0-.421-.421Zm0,0",
    transform: "translate(-68.214 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16169",
    "data-name": "Path 16169",
    d: "M104,32h1.683v.841H104Zm0,0",
    transform: "translate(-98.531 -30.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16170",
    "data-name": "Path 16170",
    d: "M104,64h2.524v.841H104Zm0,0",
    transform: "translate(-98.531 -60.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16171",
    "data-name": "Path 16171",
    d: "M152,32h5.049v.841H152Zm0,0",
    transform: "translate(-144.006 -30.317)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16172",
    "data-name": "Path 16172",
    d: "M168,64h.841v.841H168Zm0,0",
    transform: "translate(-159.165 -60.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16173",
    "data-name": "Path 16173",
    d: "M200,64h.841v.841H200Zm0,0",
    transform: "translate(-189.482 -60.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16174",
    "data-name": "Path 16174",
    d: "M232,64h.841v.841H232Zm0,0",
    transform: "translate(-219.799 -60.634)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.4e68df32298c022046523fb485324a18.svg";
export { ForwardRef as ReactComponent };